import type { AsyncAvStatuses } from "@jti/fe-common";

const isEvoVerificationStatus = (verificationStatus: string | undefined): verificationStatus is AsyncAvStatuses =>
  ["success", "pending", "failed"].includes(verificationStatus as AsyncAvStatuses);

export const getEvoVerificationStatus = (verificationStatus: string | undefined): AsyncAvStatuses =>
  isEvoVerificationStatus(verificationStatus) ? verificationStatus : "pending";
